import Card from 'Components/ContractGenerator/layouts/Card';
import CheckMark from 'Components/ContractGenerator/layouts/CheckMark';
import Section from 'Components/ContractGenerator/layouts/Section';
import Table from 'Components/ContractGenerator/layouts/Table';
import Constants from 'Components/ContractGenerator/shared/constants';
import { get } from 'lodash';
import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

const Summary = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation(['contractGenerator', 'translation']);

	const forms = useSelector(contractGeneratorSelectors.getForms);
	const formFields = useSelector(contractGeneratorSelectors.getFormFields);

	const dataToSubmit = useSelector(contractGeneratorSelectors.getDataToSubmit);

	const itemsToRender = useMemo(() => {
		const returnArray = [];

		forms.forEach(form => {
			if (typeof dataToSubmit.formData[form.name] !== 'undefined') {
				const fieldsToReturn = [];
				formFields[form.name].forEach(formFieldSet => {
					formFieldSet.forEach(formField => {
						if (typeof dataToSubmit.formData[form.name][formField.name] !== 'undefined') {
							fieldsToReturn.push({
								label: t(`translation:forms.${form.name}.${formField.name}`),
								value: dataToSubmit.formData[form.name][formField.name]
							});
						}
					});
				});

				returnArray.push({
					name: form.name,
					fields: fieldsToReturn
				});
			}
		});

		return returnArray;
	}, [forms, dataToSubmit]);

	const getEqualToKey = formName => {
		let returnValue = false;

		formFields[formName].forEach(formFieldSet =>
			formFieldSet.forEach(formField => {
				if (formField.conditions.isConditionForForm) {
					forms.forEach(form => {
						if (
							form.name === formField.conditions.form &&
							get(dataToSubmit, form.conditions.field, false) !== form.conditions.needsToBeValue
						) {
							returnValue = formField.conditions.form;
						}
					});
				}
			})
		);

		return returnValue;
	};

	return (
		<Section headline={t('pages.step3.summary.headline')} firstElementOfStep>
			{itemsToRender.map((fieldSet, index) => (
				<Fragment key={fieldSet.name}>
					<Card
						buttonSettings={{
							type: 'dark',
							text: t('app.userActions.change'),
							onClick: () =>
								dispatch(
									contractGeneratorOperations.setActiveStep(
										Constants.STEPS.STEP2,
										`viato-contract-generator-form-${fieldSet.name}`,
										true
									)
								)
						}}
						headline={t(`translation:forms.${fieldSet.name}.formName`)}
						hasButton
					>
						<Table fields={fieldSet.fields} />
						{getEqualToKey(fieldSet.name) !== false && (
							<>
								<Spacer height='l' />
								<CheckMark
									text={`${t(`translation:forms.${getEqualToKey(fieldSet.name)}.formName`)} ${t(
										'pages.step3.summary.isEqual'
									)} ${t(`translation:forms.${fieldSet.name}.formName`)}`}
								/>
							</>
						)}
					</Card>
					{index + 1 < itemsToRender.length && <Spacer height='l' />}
				</Fragment>
			))}
		</Section>
	);
};

export default Summary;
